import WhetherIconContainer from "../../../Components/Icon/WhetherIcon/WhetherIconContainer";

const WhetherIcon = () => {
  return <WhetherIconContainer />;
};

export default WhetherIcon;
